// https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
export const HTTP_STATUS_CODES = {
  tooManyRequests: 429,
  // extend on demand
}
